const initialState = {
    import_types: [],
    orgTypes: [],
    userTypes: [],
    countryList: [],
    subscriptionFeatures: [],
    apiMasters: [],
}

const masterApiReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SET_ALL_MASTER_DATA":
          return {
            ...state,
            import_types: action.data.import_type,
            orgTypes: action.data.orgType,
            userTypes: action.data.userType,
            countryList: action.data.countryList,
            subscriptionFeatures: action.data.subscriptionFeatures,
            apiMasters: action.data.apiMasters,
          }
        default:
            return state
    }
}

export default masterApiReducer;